import { ComponentMap } from '@cinch-nx/data-storyblok'

import { Intro, Overview } from '../components'

export const storyblokComponents: ComponentMap = {
  PartnershipsIntro: Intro,
  PartnershipsPartnerOverviewList: Overview,
}
